import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ProjectDisclaimerView from './ProjectDisclaimerView';

const ProjectDisclaimerRouter = () => {
  return (
    <Switch>
      <Route
        exact
        path="/projects/:projectId/project-disclaimer"
        component={ProjectDisclaimerView}
      />
    </Switch>
  );
};

export default ProjectDisclaimerRouter;
